module.exports = __webpack_public_path__ + "img/New-Evening.02137317.jpg";